import { useEffect, useState } from "react";

import { Add } from "@mui/icons-material";
import { Box, Button, Toolbar, Typography } from "@mui/material";

import { ToastContainer } from "react-toastify";

import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../../../../store/authentication/service";
import DataTable from "../../components/Playoff/PlayListTable";

export const List = ({ searchText }) => {
	const navigate = useNavigate();

	const [user, setUser] = useState();

	useEffect(() => {
		const user = getCurrentUser();
		setUser(user);
	}, []);

	return (
		<>
			<Toolbar>
				<Typography variant="h4" noWrap sx={{ flexGrow: 1 }} />
				<Button
					onClick={() => {
						if (user?.user_type === 4) {
							navigate("/upload-playoff/playoff/add");
						} else {
							navigate("/w86zjruk6q/playoff/add");
						}
					}}
					startIcon={<Add />}
					variant="contained"
					color="primary"
				>
					Add Playoff
				</Button>
			</Toolbar>
			<ToastContainer />
			<Box sx={{ px: 5 }}>
				<DataTable user={user} />
			</Box>
		</>
	);
};
